// import SuperAdminLogin from '@/components/SuperAdmin/Login'
// import SuperAdmin from '@/components/SuperAdmin/SuperAdmin'
// import SuperMasterConfiguration from '@/components/SuperAdmin/SuperMasterConfiguration'
// import SuperHomePage from '@/components/SuperAdmin/SuperMaster/SuperHomePage'
// import TimeFormat from '@/components/SuperAdmin/SuperMaster/TimeFormat'
const SuperAdminLogin = () => import('@/components/SuperAdmin/Login');
const SuperAdmin = () => import('@/components/SuperAdmin/SuperAdmin');
const SuperMasterConfiguration = () => import('@/components/SuperAdmin/SuperMasterConfiguration');
const Organization = () => import('@/components/SuperAdmin/Organization');
const AddUser = () => import('@/components/SuperAdmin/AddUser');
const BypassLogin = () => import('@/components/SuperAdmin/BypassLogin');
const ResetPassword = () => import('@/components/SuperAdmin/ResetPassword');
const HelpDesk = () => import('@/components/SuperAdmin/HelpDesk');
const SuperHomePage = () => import('@/components/SuperAdmin/SuperMaster/SuperHomePage');
const TimeFormat = () => import('@/components/SuperAdmin/SuperMaster/TimeFormat');

// import TimeZone from '@/components/SuperAdmin/SuperMaster/TimeZone'
// import DateFormat from '@/components/SuperAdmin/SuperMaster/DateFormat'
// import SignUp from '@/components/SuperAdmin/SuperMaster/SignUp'
// import VisibleUserFormat from '@/components/SuperAdmin/SuperMaster/VisibleUserFormat'
// import CertificateStyle from '@/components/SuperAdmin/SuperMaster/CertificateStyle'
// import CertificateField from '@/components/SuperAdmin/SuperMaster/CertificateField'
const TimeZone = () => import('@/components/SuperAdmin/SuperMaster/TimeZone');
const DateFormat = () => import('@/components/SuperAdmin/SuperMaster/DateFormat');
const SignUp = () => import('@/components/SuperAdmin/SuperMaster/SignUp');
const VisibleUserFormat = () => import('@/components/SuperAdmin/SuperMaster/VisibleUserFormat');
const CertificateStyle = () => import('@/components/SuperAdmin/SuperMaster/CertificateStyle');
const CertificateField = () => import('@/components/SuperAdmin/SuperMaster/CertificateField');

// import GamificationType from '@/components/SuperAdmin/SuperMaster/GamificationType'
// import GamificationBadgeGroup from '@/components/SuperAdmin/SuperMaster/GamificationBadgeGroup'
// import PaymentGateway from '@/components/SuperAdmin/SuperMaster/PaymentGateway'
// import SubscriptionType from '@/components/SuperAdmin/SuperMaster/SubscriptionType'
// import UserType from '@/components/SuperAdmin/SuperMaster/UserType'
const GamificationType = () => import('@/components/SuperAdmin/SuperMaster/GamificationType');
const GamificationBadgeGroup = () => import('@/components/SuperAdmin/SuperMaster/GamificationBadgeGroup');
const PaymentGateway = () => import('@/components/SuperAdmin/SuperMaster/PaymentGateway');
const SubscriptionType = () => import('@/components/SuperAdmin/SuperMaster/SubscriptionType');
const UserType = () => import('@/components/SuperAdmin/SuperMaster/UserType');

// import Gender from '@/components/SuperAdmin/SuperMaster/Gender'
// import Language from '@/components/SuperAdmin/SuperMaster/Language'
// import CourseCompletionRule from '@/components/SuperAdmin/SuperMaster/CourseCompletionRule'
// import CourseScoreRule from '@/components/SuperAdmin/SuperMaster/CourseScoreRule'
// import ContentCompletionRule from '@/components/SuperAdmin/SuperMaster/ContentCompletionRule'
const Gender = () => import('@/components/SuperAdmin/SuperMaster/Gender');
const Language = () => import('@/components/SuperAdmin/SuperMaster/Language');
const CourseCompletionRule = () => import('@/components/SuperAdmin/SuperMaster/CourseCompletionRule');
const CourseScoreRule = () => import('@/components/SuperAdmin/SuperMaster/CourseScoreRule');
const ContentCompletionRule = () => import('@/components/SuperAdmin/SuperMaster/ContentCompletionRule');

// import QuizType from '@/components/SuperAdmin/SuperMaster/QuizType'
// import CommunicationMode from '@/components/SuperAdmin/SuperMaster/CommunicationMode'
// import NotificationField from '@/components/SuperAdmin/SuperMaster/NotificationField'
// import NotificationEvent from '@/components/SuperAdmin/SuperMaster/NotificationEvent'
// import NotificationTemplateType from '@/components/SuperAdmin/SuperMaster/NotificationTemplateType'
const QuizType = () => import('@/components/SuperAdmin/SuperMaster/QuizType');
const CommunicationMode = () => import('@/components/SuperAdmin/SuperMaster/CommunicationMode');
const NotificationField = () => import('@/components/SuperAdmin/SuperMaster/NotificationField');
const NotificationEvent = () => import('@/components/SuperAdmin/SuperMaster/NotificationEvent');
const NotificationTemplateType = () => import('@/components/SuperAdmin/SuperMaster/NotificationTemplateType');

// import SurveyQuestionType from '@/components/SuperAdmin/SuperMaster/SurveyQuestionType'
// import Currency from '@/components/SuperAdmin/SuperMaster/Currency'
// import Conference from '@/components/SuperAdmin/SuperMaster/Conference'
// import FileType from '@/components/SuperAdmin/SuperMaster/FileType'
// import DifficultyLevel from '@/components/SuperAdmin/SuperMaster/DifficultyLevel'
// import AssignmentType from '@/components/SuperAdmin/SuperMaster/AssignmentType'
const SurveyQuestionType = () => import('@/components/SuperAdmin/SuperMaster/SurveyQuestionType');
const Currency = () => import('@/components/SuperAdmin/SuperMaster/Currency');
const Conference = () => import('@/components/SuperAdmin/SuperMaster/Conference');
const FileType = () => import('@/components/SuperAdmin/SuperMaster/FileType');
const DifficultyLevel = () => import('@/components/SuperAdmin/SuperMaster/DifficultyLevel');
const AssignmentType = () => import('@/components/SuperAdmin/SuperMaster/AssignmentType');

// import CertificateBackground from '@/components/SuperAdmin/SuperMaster/CertificateBackground'
// import QueryType from '@/components/SuperAdmin/SuperMaster/QueryType'
// import Social from '@/components/SuperAdmin/SuperMaster/Social'
// import Tool from '@/components/SuperAdmin/SuperMaster/Tool'
// import VOLPConfiguration from '@/components/SuperAdmin/SuperMaster/VOLPConfiguration'
// import NotificationFrom from '@/components/SuperAdmin/SuperMaster/NotificationFrom'
// import FileFormat from '@/components/SuperAdmin/SuperMaster/FileFormat'
// import GamicationUnit from '@/components/SuperAdmin/SuperMaster/GamicationUnit'
// import CourseConductType from '@/components/SuperAdmin/SuperMaster/CourseConductType'
const CertificateBackground = () => import('@/components/SuperAdmin/SuperMaster/CertificateBackground');
const QueryType = () => import('@/components/SuperAdmin/SuperMaster/QueryType');
const Social = () => import('@/components/SuperAdmin/SuperMaster/Social');
const Tool = () => import('@/components/SuperAdmin/SuperMaster/Tool');
const VOLPConfiguration = () => import('@/components/SuperAdmin/SuperMaster/VOLPConfiguration');
const NotificationFrom = () => import('@/components/SuperAdmin/SuperMaster/NotificationFrom');
const FileFormat = () => import('@/components/SuperAdmin/SuperMaster/FileFormat');
const GamicationUnit = () => import('@/components/SuperAdmin/SuperMaster/GamicationUnit');
const CourseConductType = () => import('@/components/SuperAdmin/SuperMaster/CourseConductType');
const FileUploadStatus = () => import('@/components/SuperAdmin/SuperMaster/FileUploadStatus');
const FileCategory = () => import('@/components/SuperAdmin/SuperMaster/FileCategory');
const ConductType = () => import('@/components/SuperAdmin/SuperMaster/ConductType');
const Skill = () => import('@/components/SuperAdmin/SuperMaster/Skill');
const QueryStatus = () => import('@/components/SuperAdmin/SuperMaster/QueryStatus');
const LinkPosition = () => import('@/components/SuperAdmin/SuperMaster/LinkPosition');
const LinkMaster = () => import('@/components/SuperAdmin/SuperMaster/LinkMaster');

const routes = [
    {
        path: '/volp-super-admin',
        name: 'volp-super-admin',
        component: SuperAdminLogin,
    },
    {
        path: '/super-admin',
        name: 'super-admin',
        component: SuperAdmin,
        props: true,
        meta:{breadcrumb: 'Dashboard'},
        children: [
            {
                path: '/super-admin-add-organization',
                name: 'super-admin-add-organization',
                component: Organization,
                meta:{breadcrumb: 'Organization'},
            },
            {
                path: '/super-admin-add-user',
                name: 'super-admin-add-user',
                component: AddUser,
                meta:{breadcrumb: 'Add  Admin User'},
            },
            {
                path: '/super-admin-help-desk',
                name: 'super-admin-help-desk',
                component: HelpDesk,
                meta:{breadcrumb: 'Help Desk'},
            },
            {
                path: '/super-admin-bypass-login',
                name: 'super-admin-bypass-login',
                component: BypassLogin,
                meta:{breadcrumb: 'Bypass Login'},
            },
            {
                path: '/super-admin-reset-password',
                name: 'super-admin-reset-password',
                component: ResetPassword,
                meta:{breadcrumb: 'Reset Password'},
            },
            {
                path: '/super-admin-master-configuration',
                name: 'super-admin-master-configuration',
                component: SuperMasterConfiguration,
                meta:{breadcrumb: 'Super-Master'},
                children: [
                    {
                        path: '/super-admin-master-home-page',
                        name: 'super-admin-master-home-page',
                        component: SuperHomePage,
                        meta:{breadcrumb: 'Home Page'},

                    },
                    {
                        path: '/super-admin-master-time-format',
                        name: 'super-admin-master-time-format',
                        component: TimeFormat,
                        meta:{breadcrumb: 'Time Format'},
                    },
                    {
                        path: '/super-admin-master-time-zone',
                        name: 'super-admin-master-time-zone',
                        component: TimeZone,
                        meta:{breadcrumb: 'Time Zone'},
                    },
                    {
                        path: '/super-admin-master-date-format',
                        name: 'super-admin-master-date-format',
                        component: DateFormat,
                        meta:{breadcrumb: 'Date Format'},
                    },
                    {
                        path: '/super-admin-master-sign-up',
                        name: 'super-admin-master-sign-up',
                        component: SignUp,
                        meta:{breadcrumb: 'SignUp'},
                    },
                    {
                        path: '/super-admin-master-visible-user-format',
                        name: 'super-admin-master-visible-user-format',
                        component: VisibleUserFormat,
                        meta:{breadcrumb: 'Visible User Format'},
                    },
                    {
                        path: '/super-admin-master-certificate-style',
                        name: 'super-admin-master-certificate-style',
                        component: CertificateStyle,
                        meta:{breadcrumb: 'Certificate Style'},
                    },
                    {
                        path: '/super-admin-master-certificate-field',
                        name: 'super-admin-master-certificate-field',
                        component: CertificateField,
                        meta:{breadcrumb: 'Certificate Field'},
                    },
                    {
                        path: '/super-admin-master-gamification-type',
                        name: 'super-admin-master-gamification-type',
                        component: GamificationType,
                        meta:{breadcrumb: 'Gamification Type'},
                    },    
                    {
                        path: '/super-admin-master-gamification-badge-group',
                        name: 'super-admin-master-gamification-badge-group',
                        component: GamificationBadgeGroup,
                        meta:{breadcrumb: 'Gamification Badge Group'},
                    },
                    {
                        path: '/super-admin-master-payment-gateway',
                        name: 'super-admin-master-payment-gateway',
                        component: PaymentGateway,
                        meta:{breadcrumb: 'Payment Gateway'},
                    },    
                    {
                        path: '/super-admin-master-subscription-type',
                        name: 'super-admin-master-subscription-type',
                        component: SubscriptionType,
                        meta:{breadcrumb: 'Subscription Type'},
                    },    
                    {
                        path: '/super-admin-master-user-type',
                        name: 'super-admin-master-user-type',
                        component: UserType,
                        meta:{breadcrumb: 'User Type'},
                    },
                    {
                        path: '/super-admin-master-gender',
                        name: 'super-admin-master-gender',
                        component: Gender,
                        meta:{breadcrumb: 'Gender'},
                    },
                    {
                        path: '/super-admin-master-language',
                        name: 'super-admin-master-language',
                        component: Language,
                        meta:{breadcrumb: 'Language'},
                    }, 
                    {
                        path: '/super-admin-master-course-completion-rule',
                        name: 'super-admin-master-course-completion-rule',
                        component: CourseCompletionRule,
                        meta:{breadcrumb: 'Course Completion Rule'},
                    },
                    
                    {
                        path: '/super-admin-master-course-score-rule',
                        name: 'super-admin-master-course-score-rule',
                        component: CourseScoreRule,
                        meta:{breadcrumb: 'Course Score Rule'},
                    },  
                    {
                        path: '/super-admin-master-content-completion-rule',
                        name: 'super-admin-master-content-completion-rule',
                        component: ContentCompletionRule,
                        meta:{breadcrumb: 'Content Completion Rule'},
                    },  
                    {
                        path: '/super-admin-master-quiz-type',
                        name: 'super-admin-master-quiz-type',
                        component: QuizType,
                        meta:{breadcrumb: 'Quiz Type'},
                    },
                    {
                        path: '/super-admin-master-communication-mode',
                        name: 'super-admin-master-communication-mode',
                        component: CommunicationMode,
                        meta:{breadcrumb: 'Communication Mode'},
                    }, 
                    {
                        path: '/super-admin-master-notification-field',
                        name: 'super-admin-master-notification-field',
                        component: NotificationField,
                        meta:{breadcrumb: 'Notification Field'},
                    },  
                    {
                        path: '/super-admin-master-notification-event',
                        name: 'super-admin-master-notification-event',
                        component: NotificationEvent,
                        meta:{breadcrumb: 'Notification Event'},
                    },  
                    {
                        path: '/super-admin-master-notification-template-type',
                        name: 'super-admin-master-notification-template-type',
                        component: NotificationTemplateType,
                        meta:{breadcrumb: 'Notification Template Type'},
                    },  
                    {
                        path: '/super-admin-master-survey-question-type',
                        name: 'super-admin-master-survey-question-type',
                        component: SurveyQuestionType,
                        meta:{breadcrumb: 'Survey Question Type'},
                    },  
                    {
                        path: '/super-admin-master-currency',
                        name: 'super-admin-master-currency',
                        component: Currency,
                        meta:{breadcrumb: 'Currency'},
                    },
                    {
                        path: '/super-admin-master-conference',
                        name: 'super-admin-master-conference',
                        component: Conference,
                        meta:{breadcrumb: 'Conference'},
                    },
                    {
                        path: '/super-admin-master-file-type',
                        name: 'super-admin-master-file-type',
                        component: FileType,
                        meta:{breadcrumb: 'File Type'},
                    },
                    {
                        path: '/super-admin-master-difficulty-level',
                        name: 'super-admin-master-difficulty-level',
                        component: DifficultyLevel,
                        meta:{breadcrumb: 'Difficulty Level'},
                    },
                    {
                        path: '/super-admin-master-assignment-type',
                        name: 'super-admin-master-assignment-type',
                        component: AssignmentType,
                        meta:{breadcrumb: 'Assignment Type'},
                    },
                    {
                        path: '/super-admin-master-certificate-background',
                        name: 'super-admin-master-certificate-background',
                        component: CertificateBackground,
                        meta:{breadcrumb: 'Certificate Background'},
                    },
                    {
                        path: '/super-admin-master-query-type',
                        name: 'super-admin-master-query-type',
                        component: QueryType,
                        meta:{breadcrumb: 'Query Type'},
                    },
                    {
                        path: '/super-admin-master-social',
                        name: 'super-admin-master-social',
                        component: Social,
                        meta:{breadcrumb: 'Social'},
                    },
                    {
                        path: '/super-admin-master-tool',
                        name: 'super-admin-master-tool',
                        component: Tool,
                        meta:{breadcrumb: 'Tool'},
                    },
                    {
                        path: '/super-admin-master-volp-configuration',
                        name: 'super-admin-master-volp-configuration',
                        component: VOLPConfiguration,
                        meta:{breadcrumb: 'VOLP Configuration'},
                    },
                    {
                        path: '/super-admin-master-notification-from',
                        name: 'super-admin-master-notification-from',
                        component: NotificationFrom,
                        meta:{breadcrumb: 'Notification From'},
                    },
                    {
                        path: '/super-admin-master-file-format',
                        name: 'super-admin-master-file-format',
                        component: FileFormat,
                        meta:{breadcrumb: 'File Format'},
                    },
                    {
                        path: '/super-admin-gamication-unit',
                        name: 'super-admin-gamication-unit',
                        component: GamicationUnit ,
                        meta:{breadcrumb: 'Gamication Unit '},
                    },
                    {
                        path: '/super-admin-master-course-conduct-type',
                        name: 'super-admin-master-course-conduct-type',
                        component: CourseConductType,
                        meta:{breadcrumb: 'Course Conduct Type'},
                    },
                    {
                        path: '/super-admin-master-file-upload-status',
                        name: 'super-admin-master-file-upload-status',
                        component: FileUploadStatus,
                        meta:{breadcrumb: 'File Upload Status'},
                    },
                    {
                        path: '/super-admin-master-file-category',
                        name: 'super-admin-master-file-category',
                        component: FileCategory,
                        meta:{breadcrumb: 'File Category'},
                    },
                    {
                        path: '/super-admin-master-conduct-type',
                        name: 'super-admin-master-conduct-type',
                        component: ConductType,
                        meta:{breadcrumb: 'Conduct Type'},
                    },
                    {
                        path: '/super-admin-master-skill',
                        name: 'super-admin-master-skill',
                        component: Skill,
                        meta:{breadcrumb: 'Skill'},
                    },
                    {
                        path: '/super-admin-master-query-status',
                        name: 'super-admin-master-query-status',
                        component: QueryStatus,
                        meta:{breadcrumb: 'Query Status'},
                    },
                    {
                        path: '/super-admin-master-link-position',
                        name: 'super-admin-master-link-position',
                        component: LinkPosition,
                        meta:{breadcrumb: 'Link Position'},
                    },
                    {
                        path: '/super-admin-master-link-master',
                        name: 'super-admin-master-link-master',
                        component: LinkMaster,
                        meta:{breadcrumb: 'Link Master'},
                    }, 
                ],
            },
        ]

    },
 
]

export default routes